<template>
    <div class="z-10">
        <PageComponent 
            :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
            :addButtonLabel="addButtonLabel"
            @handleAddNew="addNewFiscalPeriod"
            :searchFilters="searchFilters"
            @searchPage="searchFiscalPeriods"
            @resetFilters="resetFilters"
            @removeItem="removeFiscalPeriod"
            @removeSelectedItems="removeFiscalPeriods"
            @printList="printList"
            :addingRight="addingRight"
            :removingRight="removingRight"
            :rightsModule="rightsModule"
            :columns="tableColumns"
            :rows="periodList"
            :actions="actions"
            :idField="idField"
            @handleSelectionChange="handleSelectionChange"
            @handleActionClick="handleActionClick"
            :count="propCount"
            :currentPage="currentPage"
            :result="propArrLen"
            @loadPrev="loadPrev"
            @loadNext="loadNext"
            @firstPage="firstPage"
            @lastPage="lastPage"
            :showNextBtn="showNextBtn"
            :showPreviousBtn="showPreviousBtn"
        />
        <MovableModal v-model:visible="propModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader" @closeModal="closeModal">
            <DynamicForm 
                :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                :displayButtons="displayButtons" @handleSubmit="createFiscalPeriod" @handleReset="handleReset"
            />
        </MovableModal>
        <MovableModal v-model:visible="appModalVisible" :title="title1" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
        :loader="modal_loader1" @showLoader="showModalLoader1" @hideLoader="hideModalLoader1" @closeModal="closeModal"
    >
            <DynamicForm 
                :fields="formFields1" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                :displayButtons="displayButtons" @handleSubmit="closeFiscalPeriod" @handleReset="handleReset"
            />
        </MovableModal>
    </div>
</template>

<script>
import axios from "axios";
import { ref, computed, onMounted, onBeforeMount, watch} from 'vue';
import PageComponent from '@/components/PageComponent.vue';
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import Swal from 'sweetalert2';

export default{
    name: 'Fiscal_Periods',
    components:{
        PageComponent, MovableModal,DynamicForm
    },
    setup(){
        const store = useStore();     
        const toast = useToast();
        const loader = ref('none');
        const modal_loader = ref('none');
        const modal_loader1 = ref('none');
        const ledComponentKey = ref(0);
        const period_end_date = ref('');
        const idField = 'fiscal_period_id';
        const addButtonLabel = ref('New Fiscal Period');
        const addingRight = ref('Adding Fiscal Periods');
        const removingRight = ref('Deleting Fiscal Periods');
        const rightsModule = ref('Accounts');
        const title = ref('Fiscal Period Details');
        const title1 = ref('Closing Fiscal Period');
        const submitButtonLabel = ref('Add');
        const selectedIds = ref([]);
        const periodList = ref([]);
        const propResults = ref([]);
        const propArrLen = ref(0);
        const propCount = ref(0);
        const pageCount = ref(0);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const propModalVisible = ref(false);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('150px');
        const modal_left = ref('400px');
        const modal_width = ref('30vw');
        const ledgerID = ref(null);
        const periodID = ref(null);
        const ledgerArr = computed(()=> store.state.Ledgers.ledgerArr);
        const appModalVisible = ref(false);
        const isEditing = computed(()=> store.state.Fiscal_Periods.isEditing);
        const selectedPeriod = computed(()=> store.state.Fiscal_Periods.selectedPeriod);
        const showModal = ref(false);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Year", key:"fiscal_year"},
            {label: "Period", key:"period_name"},
            {label: "Start Date", key: "start_date"},
            {label: "End Date", key: "end_date"},
            {label: "Status", key: "status", txtColor: "statusColor"},
        ])
        const actions = ref([
            {name: 'close', icon: 'fa fa-sign-out', title: 'Close Period', rightName: 'Closing Fiscal Period'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Period', rightName: 'Deleting Fiscal Periods'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);

        const searchFilters = ref([
            
        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };

        const calculateEndDate = (value) =>{
            if (value) {
                const startDate = new Date(value);
                // Assuming the fiscal year ends exactly one year after the start date minus one day
                const endDate = new Date(startDate);
                endDate.setFullYear(startDate.getFullYear() + 1);
                endDate.setDate(endDate.getDate() - 1);
                period_end_date.value = endDate.toISOString().split('T')[0]; // Format to 'YYYY-MM-DD'
            }
        };

        const formFields = ref([]);
        const updateFormFields = () => {
            formFields.value = [
                { type: 'text', name: 'fiscal_year',label: "Fiscal Year", value: selectedPeriod.value?.fiscal_year || '', required: true },
                { type: 'date', name: 'start_date',label: "Start Date", value: selectedPeriod.value?.start_date || '', required: true, method: calculateEndDate },
                { type: 'date', name: 'end_date',label: "End Date", value: selectedPeriod.value?.end_date || period_end_date.value, required: true },
            ];
        };
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            periodID.value = null;
            ledgerID.value = null;
            ledComponentKey.value += 1;
        }

        watch([selectedPeriod, period_end_date], () => {
            if (selectedPeriod.value) {
                updateFormFields();
            }
            if(period_end_date.value){
                formFields.value[2].value = period_end_date.value
            }
            
        }, { immediate: true });
        
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createFiscalPeriod = async() =>{
            showModalLoader();
            let formData = {
                period_name: formFields.value[0].value,
                fiscal_year: formFields.value[0].value,
                start_date: formFields.value[1].value,
                end_date: formFields.value[2].value,
                status: "Open",
                company: companyID.value
        }

            errors.value = [];
            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true){
                    errors.value.push(formFields.value[i].label);
                }
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Fiscal_Periods/createFiscalPeriod', formData);
                    if (response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Success!');
                        handleReset();
                    } else {
                        toast.error('An error occurred while creating the Fiscal Period.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Fiscal Period: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchFiscalPeriods();
                }
            }
        }
        const fetchLedgers = async() =>{
            await store.dispatch('Ledgers/fetchLedgers', {company:companyID.value})
        };
        const handleSelectedLedger = async(option) =>{
            await store.dispatch('Ledgers/handleSelectedLedger', option)
            ledgerID.value = store.state.Ledgers.ledgerID;
        };
        const clearSelectedLedger = async() =>{
            await store.dispatch('Ledgers/updateState', {ledgerID: ''});
            ledgerID.value = ""
        };
        const formFields1 = ref([
            {  
                type:'search-dropdown', label:"Ledger", value: ledgerID.value, componentKey: ledComponentKey,
                selectOptions: ledgerArr, optionSelected: handleSelectedLedger, required: true,
                searchPlaceholder: 'Select Ledger...', dropdownWidth: '550px', updateValue: "",
                clearSearch: clearSelectedLedger
            },
        ]);
        const showModalLoader1 = () =>{
            modal_loader1.value = "block";
        }
        const hideModalLoader1 = () =>{
            modal_loader1.value = "none";
        }
        const closeFiscalPeriod = async() =>{
            if(ledgerID.value != ""){
                showModalLoader1();
                let formData = {
                    company: companyID.value,
                    fiscal_period: periodID.value,
                    ledger: ledgerID.value
                }
                try {
                    await axios.post('api/v1/closing-fiscal-period/', formData)
                    .then((response)=>{
                        if(response.data.msg === "Success"){
                            hideModalLoader1();
                            toast.success("Success!");
                            handleReset();
                            appModalVisible.value = false;
                            searchFiscalPeriods();
                        }else{
                            toast.error('An error occurred while closing Fiscal Period.');
                        }                   
                    })
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to close Fiscal Period: ' + error.message);
                } finally {
                    hideModalLoader1();
                }              
            }              
            else{
                toast.error('No Ledger Selected')
            }
        };

        const removeFiscalPeriod = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    fiscal_period: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Fiscal_Periods/deleteFiscalPeriod',formData)
                    if(response && response.status == 200){
                        toast.success("Fiscal Period Removed Succesfully");
                        searchFiscalPeriods();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Fiscal Period: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Fiscal Period") 
            }else{
                toast.error("Please Select A Fiscal Period To Remove")
            }
        }
        const removeFiscalPeriods = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    fiscal_period: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Fiscal_Periods/deleteFiscalPeriod',formData)
                    if(response && response.status == 200){
                        toast.success("Fiscal Period(s) Removed Succesfully");
                        searchFiscalPeriods();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Fiscal Period(s): ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else{
                toast.error("Please Select A Fiscal Period To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchFiscalPeriods = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                name: "",
                company_id: companyID.value
            } 
            axios
            .post(`api/v1/fiscal-periods-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                periodList.value = response.data.results;
                store.commit('Fiscal_Periods/LIST_PERIODS', periodList.value)
                propResults.value = response.data;
                propArrLen.value = periodList.value.length;
                propCount.value = propResults.value.count;
                pageCount.value = Math.ceil(propCount.value / 50);
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        }
        const resetFilters = () =>{
            currentPage.value = [];
            store.commit('Fiscal_Periods/RESET_SEARCH_FILTERS')
            searchFiscalPeriods();
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchFiscalPeriods();
            // scrollToTop();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchFiscalPeriods();
            // scrollToTop(); 
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchFiscalPeriods();
            // scrollToTop();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchFiscalPeriods();
            // scrollToTop();
        }
        const addNewFiscalPeriod = () =>{
            updateFormFields();
            store.dispatch("Fiscal_Periods/updateState",{selectedPeriod:null, isEditing:false})
            propModalVisible.value = true;
            handleReset();
            flex_basis.value = '1/2';
            flex_basis_percentage.value = '50';
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if(action == 'delete'){
                const periodID = row[idField];
                let formData = {
                    company: companyID.value,
                    fiscal_period: periodID
                }
                await store.dispatch('Fiscal_Periods/deleteFiscalPeriod',formData)
                searchFiscalPeriods();
            }else if(action == 'close'){
                const periodStatus = row['status'];
                if(periodStatus == 'Closed'){
                    Swal.fire({
                        title: "Are you sure?",
                        text: `Do you wish to open Fiscal Period?`,
                        type: 'warning',
                        showCloseButton: true,
                        showCancelButton: true,
                        confirmButtonText: 'Yes Open Fiscal Period!',
                        cancelButtonText: 'Cancel!',
                        customClass: {
                            confirmButton: 'swal2-confirm-custom',
                            cancelButton: 'swal2-cancel-custom',
                        },
                        showLoaderOnConfirm: true,
                        }).then((result) => {
                        if (result.value) {
                            axios.post(`api/v1/opening-fiscal-period/`,formData)
                            .then((response)=>{
                            if(response.data.msg == "Success"){
                                Swal.fire("Success!", {
                                    icon: "success",
                                }); 
                                searchFiscalPeriods();
                            }else{
                                Swal.fire({
                                title: "Failed to open Fiscal Period",
                                icon: "warning",
                                });
                            }                   
                            })
                            .catch((error)=>{
                            console.log(error.message);
                            Swal.fire({
                                title: error.message,
                                icon: "warning",
                            });
                            })
                        }else{
                            Swal.fire(`Fiscal Period has not been opened!`);
                        }
                    });
                    let formData = {
                        company: companyID.value,
                        fiscal_period: row[idField]
                    }
                }else{
                    fetchLedgers();
                    periodID.value = row[idField];
                    appModalVisible.value = true;
                }
                
            }
        }
        const closeModal = () =>{
            propModalVisible.value = false;
        }
        onBeforeMount(()=>{
            searchFiscalPeriods();
            
        })
        return{
            title, searchFiscalPeriods,resetFilters, addButtonLabel, searchFilters, tableColumns, periodList,
            currentPage,propResults, propArrLen, propCount, pageCount, showNextBtn, showPreviousBtn,
            loadPrev, loadNext, firstPage, lastPage, idField, actions, handleActionClick, propModalVisible, closeModal,
            submitButtonLabel, showModal, addNewFiscalPeriod, showLoader, loader, hideLoader, modal_loader, modal_top, modal_left, modal_width,displayButtons,
            showModalLoader, hideModalLoader, createFiscalPeriod, formFields, handleSelectionChange, flex_basis,flex_basis_percentage,
            removeFiscalPeriod, removeFiscalPeriods,addingRight,removingRight,rightsModule,
            appModalVisible, modal_loader1, title1, formFields1, closeFiscalPeriod,showModalLoader1, hideModalLoader1
        }
    }
};
</script>